import React from 'react';

const FAQ = () => {
    return (
        <div>
            <h2>this is faq
            </h2>
        </div>
    );
};

export default FAQ;